import * as actionTypes from "../actions/actionTypes";

const initState = {
    itemLoading: false,
    vehicle: null,
    error : null,
    checkingHasVideo:true,
    hasVideo : null
};

const initGetDetailItem = (state, action)=>{
    return {
        ...state,
        itemLoading: action.itemLoading,
    }
};

const successGetDetailItem = (state, action)=>{
    return {
        ...state,
        itemLoading: action.itemLoading,
        vehicle: action.vehicle,
    }
};

const failGetDetailItem = (state, action)=>{
    return {
        ...state,
        error : action.error
    }
};

const CheckingHasVideo = (state, action)=>{
    return {
        ...state,
        checkingHasVideo : action.checkingHasVideo
    }
};

const chechItemHasVideo = (state, action)=>{
    return {
        ...state,
        hasVideo : action.hasVideo,
        checkingHasVideo : action.checkingHasVideo
    }
}

const reducer = (state = initState, action) => {
    switch(action.type){
        case actionTypes.INIT_GET_DETAIL_ITEM:
        return initGetDetailItem(state, action);
        case actionTypes.SUCCESS_GET_DETAIL_ITEM:
        return successGetDetailItem(state, action);
        case actionTypes.FAIL_GET_DETAIL_ITEM:
        return failGetDetailItem(state, action);
        case actionTypes.CHECK_ITEM_HAS_VIDEO:
        return chechItemHasVideo(state, action);
        case actionTypes.CHECKING_HAS_VIDEO:
        return CheckingHasVideo(state, action);
        default :
        return state;
    }
};

export default reducer